module.exports = __webpack_public_path__ + "static/flags/ID-e80a9c64f294fb32ccef5239a3b60f73.gif";